<div class=" w-full h-full overflow-hidden">
    <div class="flex flex-col">
        <div class="flex justify-between mb-1">
            <h3 class="site-name-color">Category Filter </h3>
            <span class="flex items-center " mat-dialog-close mat-icon-button
                style="cursor: pointer">Close
                <mat-icon [svgIcon]="'custom:close'"></mat-icon>
            </span>
        </div>
    </div>
    <hr class="w-full my-4">

    <div class="flex flex-col w-full relative"  style="    height: 20vh !important;
    overflow-y: hidden;">
        <div *ngFor="let category of categories" >
            <mat-checkbox [checked]="isChecked(category)" (click)="$event.stopPropagation()" 
            class="select py-2 pl-5 w-full right-4 relative bottom-[1vh]" (change)="categorySelected(category,$event)">{{category.category_name}}
            </mat-checkbox> 
        </div>
    </div>
    
    <div class=" mb-4 mt-3 mr-4 flex justify-end">
        <button (click)="onSubmitClick()" class="bg-[#1A347F] text-white font-bold py-2 px-4 rounded h-[4vh]">
            <p style="color: #fff;
            font-family: 'Inter var';
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;">Apply Filter</p>
        </button>
    </div>
</div>
